import { useDispatch } from 'react-redux'
import { useState } from 'react'

import { actionFetchTerms } from 'modules/Referral/ReferralLinks/actions'

export const useFinancialTerms = () => {
  const [fetchTermsProgress, setFetchTermsProgress] = useState(false)
  const [fetchTermsFinished, setFetchTermsFinished] = useState(false)
  const [fetchTermsFailed, setFetchTermsFailed] = useState(false)

  const dispatch = useDispatch()

  const fetchTerms = () =>
    new Promise((resolve, reject) => {
      setFetchTermsProgress(true)
      setFetchTermsFailed(false)
      dispatch(actionFetchTerms({ meta: { resolve, reject } }))
    })
      .catch(() => setFetchTermsFailed(true))
      .finally(() => {
        setFetchTermsProgress(false)
        setFetchTermsFinished(true)
      })

  fetchTerms.progress = fetchTermsProgress
  fetchTerms.finished = fetchTermsFinished
  fetchTerms.failed = fetchTermsFailed

  return { fetchTerms }
}
